export const fullHeight = 'calc(100vh - 66px)'